import { useEffect, useRef, useState } from "react";
import { Row, Col, Form, Button, Spinner } from "react-bootstrap";
import Header from "../../components/header/header";
import CustomModal from "../../components/modal/Modal";
import "./solicitacoesRegister.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faWindowClose } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";
import {
  postSolicitacao,
  getSolicitacaoById,
  updateSolicitacao,
} from "../../services/api_cadastros_solicitacoes_servico";
import Swal from "sweetalert2";
import { getUnidades } from "../../services/api_unidades";
import { getApplications } from "../../services/api_aplicacoes";
import { getUserById } from "../../services/api_cadastro_users";
import Preview from "../../components/Preview/Preview";
import { getUnidadesById } from "../../services/api_cadastros_unidades";
import { getEmpresas } from "../../services/api_base";
import POLLING_INTERVAL from "../../hooks/Interval/interval";

const SolicitacoesRegister = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state?.id;
  const [solicitacao, setSolicitacao] = useState("");
  const [anexo, setAnexo] = useState("");
  const [anexoAnterior, setAnexoAnterior] = useState("");
  const [id_aplicacao, setIdAplicacao] = useState("");
  const [id_empresa, setIdEmpresa] = useState("");
  const [id_unidade, setIdUnidade] = useState("Selecione");
  const [empresasListagem, setEmpresasListagem] = useState([]);
  const [unidadesListagem, setUnidadesListagem] = useState([]);
  const [unidadesBackup, setUnidadesBackup] = useState([]);
  const [aplicacoesListagem, setAplicacoesListagem] = useState([]);
  const [dataHoraAprovacao, setDataHoraAprovacao] = useState("");
  const [dataHoraCancelamento, setDataHoraCancelamento] = useState("");
  const [justificativa, setJustificativa] = useState("");
  const [situacao, setSituacao] = useState("");
  const [id_user, setIdUser] = useState("");
  const [solicitante, setSolicitante] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});
  const [isLoading, setLoading] = useState(true);
  const [isSaving, setSaving] = useState(false)

  const inputRefs = {
    Anexo: useRef(null),
    Empresa: useRef(null),
    Unidade: useRef(null),
    Aplicacoes: useRef(null),
    Solicitacao: useRef(null)
  };

  const fetchSolicitacao = async () => {
    try {
      const response = await getSolicitacaoById(id);
      const solicitacaoDados = response.data.solicitacaoServico;
      setSolicitacao(solicitacaoDados.solicitacao || "");
      setAnexo(solicitacaoDados.anexo || "")
      setAnexoAnterior(solicitacaoDados.anexo || "");
      setIdAplicacao(solicitacaoDados.id_aplicacao || "");
      setIdEmpresa(solicitacaoDados.unidade.id_empresa);
      setIdUnidade(solicitacaoDados.id_unidade || "");
      setDataHoraAprovacao(solicitacaoDados.data_hora_aprovacao || "");
      setDataHoraCancelamento(solicitacaoDados.data_hora_cancelamento || "");
      setJustificativa(solicitacaoDados.justificativa || "");
      setSituacao(solicitacaoDados.situacao || "");
      setIdUser(solicitacaoDados.id_user || "");
      if (solicitacaoDados.id_user) {
        const userData = await getUserById(solicitacaoDados.id_user);
        if (userData) {
          //console.log(userData);
          setSolicitante(userData.data.User.nome);
          //console.log(solicitante);
        }
      }
    } catch (error) {
      console.error("Erro ao obter os dados da solicitação:", error);
    }
  };

  const fetchEmpresas = async () => {
    try {
      const response = await getEmpresas();
      if (response) {
        const empresasAtivas = response.data.empresas.filter(
          (empresa) => empresa.deleted_at == null
        );
        setEmpresasListagem(empresasAtivas);
        //console.log(response)
      } else {
        console.error("A resposta da API não é uma array:");
      }
    } catch (error) {
      console.error("Erro ao obter empresas: ", error);
    }
  };

  const fetchUnidades = async () => {
    try {
      const response = await getUnidades();
      if (response) {
        const unidadesAtivas = response.data.unidades.filter(
          (unidade) => unidade.deleted_at == null
        );
        setUnidadesListagem(unidadesAtivas);
        setUnidadesBackup(unidadesAtivas);
      } else {
        console.error("A resposta da API não é uma array:");
      }
    } catch (error) {
      console.error("Erro ao obter empresas e unidades:", error);
    }
  };

  const fetchAplicacoes = async () => {
    try {
      const response = await getApplications();
      if (response) {
        const aplicacoesAtivas = response.data.Aplicacao.filter(
          (aplicacao) => aplicacao.deleted_at == null
        );
        setAplicacoesListagem(aplicacoesAtivas);
        setLoading(false);
      } else {
        console.error("A resposta da API não é uma array:");
      }
    } catch (error) {
      console.error("Erro ao obter aplicações:", error);
    }
  };

  useEffect(() => {
    if (id) {
      fetchSolicitacao();
    }

    fetchEmpresas();
    fetchUnidades();
    fetchAplicacoes();
    const interval = setInterval(()=>{
      fetchAplicacoes()
    }, POLLING_INTERVAL);
    return () => clearInterval(interval);
  }, [id, solicitante]);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenModal = (title, body) => {
    setModalContent({ title, body });
    setShowModal(true);
  };

  const validarInputs = () => {
    if (!solicitacao || !id_unidade || !id_aplicacao) {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "O preenchimento dos campos Solicitação, Unidade e Aplicação é obrigatório.",
      });
      return false;
    }
    return true;
  };

  const addCadastro = async (body) => {
    try {
      const response = await postSolicitacao(body);
      if (response && response.status === 200) {
        regret();
      }
    } catch (error) {
      if (error.response && error.response.status === 422) {
        handleOpenModal(
          "Erro de validação",
          "Houve um erro na validação dos dados."
        );
      } else if (error.response && error.response.status === 500) {
        handleOpenModal(
          "Erro interno do servidor",
          "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde."
        );
      } else {
        console.error("Erro ao atualizar os dados:", error);
        handleOpenModal(
          "Erro ao atualizar os dados",
          "Por favor, tente novamente mais tarde."
        ); // Exibir mensagem genérica de erro
      }
    }finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };
  const newUpdate = async (body) => {
    try {
      // if (body.data_hora_aprovacao) {
      //   delete body.solicitacao;
      // }
      const response = await updateSolicitacao(id, body);
      if (response && response.status === 200) {
        regret();
      }
    } catch (error) {
      if (error.response && error.response.status === 422) {
        handleOpenModal(
          "Erro de validação",
          "Houve um erro na validação dos dados."
        );
      } else if (error.response && error.response.status === 500) {
        handleOpenModal(
          "Erro interno do servidor",
          "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde."
        );
      } else {
        console.error("Erro ao atualizar os dados:", error);
        handleOpenModal(
          "Erro ao atualizar os dados",
          "Por favor, tente novamente mais tarde."
        ); // Exibir mensagem genérica de erro
      }
    }finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const handleSalvar = () => {
    if (validarInputs()) {
      setSaving(true)
      let body = {
        solicitacao,
        anexo,
        id_aplicacao,
        id_unidade,
        id_user: localStorage.getItem("userId"),
        situacao: "0",
      };

      if (id) {
        delete body.id_user;
        if (Array.isArray(anexo)) {
          console.error("O campo 'anexo' não pode ser um array");
          return;
        }        
        anexo !== anexoAnterior ? (body.anexo = anexo) : delete body.anexo;
        console.log("Dados enviados na solicitação:", body);
        newUpdate(body);
      } else {
        addCadastro(body);
      }
    }
  };

  const handleSolicitacao = (e) => {
    const value = e.target.value;
    if (value.length <= 255) {
      setSolicitacao(value);
    } else {
      handleOpenModal(
        "Número de caracteres excedidos",
        "O campo Solicitação não pode ultrapassar 255 caracteres"
      );
    }
  };

  const handleAplicacoesUnidade = async (idUnidade) => {
    if (idUnidade === "") {
      setIdUnidade("");
      setAplicacoesListagem([]);
      return;
    } else {
      try {
        const response = await getUnidadesById(idUnidade);
        const arrayAplicacoesUnidade = response.data.unidade.aplicacoes;

        if (
          Array.isArray(arrayAplicacoesUnidade) &&
          arrayAplicacoesUnidade.length > 0
        ) {
          //console.log(arrayAplicacoesUnidade);
          //console.log("entrei agui");
          setAplicacoesListagem(arrayAplicacoesUnidade);
        } else {
          setAplicacoesListagem([]);
          return Swal.fire({
            icon: "warning",
            title: "Oops!",
            text: "Essa unidade ainda não tem aplicações cadastradas. Cadastre uma ou selecione outra unidade.",
          });
        }
      } catch (error) {
        console.error(error);
        return Swal.fire({
          icon: "error",
          title: "Erro ao carregar as aplicações da unidade selecionada.",
          text: "Não foi possível carregar as aplicações da unidade selecionada. Tente novamente.",
        });
      }
    }
  };

  const handleDeleteImage = () => {
    setAnexo(null);
  };

  const handleUnidades = (idEmpresa) => {
    //console.log(idEmpresa);
    if (idEmpresa === "") {
      setIdUnidade("");
      return;
    }

    const unidadesEmpresaSelecionada = unidadesBackup.filter(
      (unidade) => unidade.id_empresa.toString() === idEmpresa.toString()
    );

    if (unidadesEmpresaSelecionada.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Nenhuma unidade encontrada",
        text: "Não existe nenhuma unidade cadastrada nesta empresa.",
      });
    }

    setUnidadesListagem(unidadesEmpresaSelecionada);
  };

  useEffect(() => {
    if (!isLoading) {
      handleUnidades(id_empresa);
    }
  }, [id_empresa]);

  const handleKeyDown = (e, nextFieldRef) => {
    if (e.key === 'Enter' && nextFieldRef.current) {
      e.preventDefault();
      const elementToFocus = nextFieldRef.current.inputRef || nextFieldRef.current;
  
      if (typeof elementToFocus.focus === 'function') {
        elementToFocus.focus();
      } else {
        console.warn('O elemento de input não tem o método focus.');
      }
    }
  };
  

  const regret = () => {
    window.history.back();
  };

  return (
    <>
      <Header title="Cadastros / Cadastro de Solicitação de Serviço" />
      <div className="content-wrapper pl-5 pr-5 pt-2">
        {id && isLoading ? (
          <div className="center-btn">
            <h5 className="mb-5">Carregando dados</h5>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <Form className="mt-4">
            <Row>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formEmpresa">
                  <Form.Label>Empresa:</Form.Label>
                  <Form.Control
                    as="select"
                    placeholder="Selecione"
                    value={id_empresa}
                    onChange={(e) => {
                      setIdEmpresa(e.target.value);
                    }}
                    ref={inputRefs.Empresa}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Unidade)}
                  >
                    <option value="">Selecione</option>
                    {empresasListagem.map((empresa) => (
                      <option key={empresa.id} value={empresa.id}>
                        {empresa.nome}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>

              <Col md={4} className="mb-3">
                <Form.Group controlId="formUnidade">
                  <Form.Label>Unidade:</Form.Label>
                  <Form.Control
                    as="select"
                    placeholder="Selecione"
                    value={id_unidade}
                    disabled={!id_empresa}
                    onChange={(e) => {
                      setIdUnidade(e.target.value);
                      handleAplicacoesUnidade(e.target.value);
                    }}
                    ref={inputRefs.Unidade}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Aplicacoes)}
                  >
                    <option value="">Selecione</option>
                    {unidadesListagem.map((unidade) => (
                      <option key={unidade.id} value={unidade.id}>
                        {unidade.nome}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>

              <Col md={4} className="mb-3">
                <Form.Group controlId="formAplicacao">
                  <Form.Label>Aplicação:</Form.Label>
                  <Form.Control
                    as="select"
                    placeholder="Selecione"
                    disabled={id_unidade === "Selecione" ? true : false}
                    value={id_unidade === "Selecione" ? null : id_aplicacao}
                    onChange={(e) => setIdAplicacao(e.target.value)}
                    ref={inputRefs.Aplicacoes}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Anexo)}
                  >
                    <option value="">Selecione</option>
                    {aplicacoesListagem?.map((aplicacao) => (
                      <option key={aplicacao.id} value={aplicacao.id}>
                        {aplicacao.descricao}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={4} className="mb-3">
                <Form.Group>
                  <Form.Label>Anexo:</Form.Label>
                  <Form.Control
                    id="formAnexo"
                    type="file"
                    accept="image/png,.jpg,.jpeg"
                    value={anexo?.fileName}
                    onChange={(e) => setAnexo(e.target.files[0])}
                    ref={inputRefs.Anexo}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Solicitacao)}
                  />
                  {anexo ? (
                    <Preview anexo={anexo} handleDelete={handleDeleteImage} />
                  ) : null}
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={12} className="mb-3">
                <Form.Group controlId="formSolicitacao">
                  <Form.Label>Solicitação:</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={5}
                    placeholder="Descreva a solicitação"
                    value={solicitacao}
                    onChange={handleSolicitacao}
                    ref={inputRefs.Solicitacao}
                  />
                </Form.Group>
              </Col>
            </Row>
            <div className="center-two-btn d-flex justify-content-center ">
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={handleSalvar}
                disabled = {isSaving}
              >
                {isSaving ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <FontAwesomeIcon icon={faSave} />
                )}
              </Button>
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={regret}
              >
                <FontAwesomeIcon icon={faWindowClose} />
              </Button>
            </div>
          </Form>
        )}
      </div>

      <CustomModal
        show={showModal}
        handleClose={handleCloseModal}
        title={modalContent.title}
        body={modalContent.body}
      />
    </>
  );
};
export default SolicitacoesRegister;
